import * as L from "leaflet";

import { DigitalRoadworkDto } from "../services/bbo-client.service";
import { Point } from "./point.model";
import { ROADWORK_SECTION_POLYLINES_PANE, SectionType } from "./roadwork-section.model";

export class RoadworkSegmentAssignment {
	id?: number;
	roadworkId: string;
	citsState: string;
	digitalEquipmentStart?: string;
	digitalEquipmentEnd?: string;
	sectionId: number;
	speed: number;
	sectionType: SectionType;
	order: number;
	isDismantling?: boolean;
	canRoadworkBeAutomaticallyClosed: boolean | undefined;
	latStart: number | undefined;
	lonStart: number | undefined;
	latEnd: number | undefined;
	lonEnd: number | undefined;
	trace: Point[];

	constructor(res: DigitalRoadworkDto) {
		this.id = res.id;
		this.roadworkId = res.roadworkId as string;
		this.citsState = res.citsState as string;
		this.digitalEquipmentStart = res.digitalEquipmentStart;
		this.digitalEquipmentEnd = res.digitalEquipmentEnd;
		this.speed = res.speed as number;
		this.sectionId = res.sectionId as number;
		this.sectionType = res.sectionType as SectionType;
		this.order = res.order as number;
		this.isDismantling = res.isDismantling;
		this.canRoadworkBeAutomaticallyClosed = res.canRoadworkBeAutomaticallyClosed;
		this.latStart = res.latStart;
		this.lonStart = res.lonStart;
		this.latEnd = res.latEnd;
		this.lonEnd = res.lonEnd;
		this.trace = res.trace as Point[];
	}

	/** Indicates wether this assignment is invalid which is usally the case when state of the roadwork is "nichtZuordenbar". */
	get IsInvalidAssignment(): boolean {
		return (
			(this.digitalEquipmentStart === undefined || this.digitalEquipmentStart === null) &&
			(this.digitalEquipmentEnd === undefined || this.digitalEquipmentEnd === null)
		);
	}

	public isEquipmentAssigned(assetId: string): boolean {
		return assetId === this.digitalEquipmentStart || assetId === this.digitalEquipmentEnd;
	}

	public getTooltipBaseInfo(segmentNumber: number): string {
		return `Segment ${segmentNumber}`;
	}

	public getPolyline(weight: number, color: string): L.Polyline | null {
		if (!!this.trace) {
			return L.polyline(
				this.trace.map((coord) => [coord.lat, coord.lon]),
				{
					pane: ROADWORK_SECTION_POLYLINES_PANE,
					weight: weight,
					color: color,
					lineCap: "inherit",
				},
			);
		}
		return null;
	}
}
